module.exports = __webpack_public_path__ + "img/order-active-subnav.1b9b6ef0.svg";